import { client } from '../client';
import { IOneReport } from './types/IOneReport';

export const deleteOneReportMedia = async (one_report_id: string, one_report_media_id: string): Promise<IOneReport> => {
  const { data } = await client.delete<IOneReport>(`/one_reports/${one_report_id}/media/${one_report_media_id}`);

  return data;
};
